import ProfileOrgsSummary from "./ProfileOrgsSummary";

export default ProfileOrgsSummary;
